import { render, staticRenderFns } from "./goodsInvitation.vue?vue&type=template&id=16fbd35a&scoped=true&"
import script from "./goodsInvitation.vue?vue&type=script&lang=js&"
export * from "./goodsInvitation.vue?vue&type=script&lang=js&"
import style0 from "./goodsInvitation.vue?vue&type=style&index=0&id=16fbd35a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fbd35a",
  null
  
)

export default component.exports